import { useEffect, useState } from 'react';
import axios from 'axios';

// Admin-controlled visibility of app sections (films_libres, mymouv, myjob, home_tab). Shared cache + refresh event.
const DEFAULTS = { films_libres: true, mymouv: true, myjob: true, home_tab: true, explore_app: true, theme_modes: true };
let cache = null;
let inflight = null;
const listeners = new Set();

export const fetchSectionsVisibility = async (force = false) => {
  if (cache && !force) return cache;
  if (!inflight) {
    inflight = axios.get('/api/settings/sections-visibility')
      .then((r) => { cache = { ...DEFAULTS, ...(r.data || {}) }; return cache; })
      .catch(() => cache || DEFAULTS)
      .finally(() => { inflight = null; });
  }
  const v = await inflight;
  listeners.forEach((fn) => fn(v));
  return v;
};

export const refreshSectionsVisibility = () => fetchSectionsVisibility(true);

export const useSectionsVisibility = () => {
  const [vis, setVis] = useState(cache || DEFAULTS);
  useEffect(() => {
    listeners.add(setVis);
    fetchSectionsVisibility().then(setVis);
    return () => listeners.delete(setVis);
  }, []);
  return { ...vis, homeHidden: !vis.home_tab, loaded: !!cache };
};

export default useSectionsVisibility;
